<template>
	<div class="flex-1">
		<div class="empty-state">
			<img class="img-fluid" src="../../../assets/icons/Danger.svg" alt="">
			<div class="f-16 f-bold">{{ message }}</div>
			<div class="f-14 f-c-midgrey">{{ subMessage }}</div>
			<button class="btn btn-outline-small bg-white" @click="action">
				{{ btnText }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOWarningState",
	props: {
		message: String,
		subMessage: String,
		btnText: String,
	},
	methods: {
		action(payload) {
			this.$emit("action", payload)
		}
	}
}
</script>